<template>
    <div class="">
        <div class="serve-list-img">
            <img src="../assets/index-img.png">
        </div>
        <div class="serve-list-box">
            <van-list class="service-list" v-model="loading"
                      :finished="finished"
                      finished-text="eCentime, living like a local"
                      @load="onLoad">
                <van-cell>
                    <van-row @click="goToWhere(0)">
                            <van-col class="serve-icon">
                                <img src="../assets/defend.png" class="serve-tab-img">
                            </van-col>
                            <van-col class="serviceItemDesc">
                                <div class="service-tab">抗疫专区</div>
                                <div class="more-detail">免费申领口罩，抗疫实时信息</div>
                            </van-col>
                    </van-row>
                </van-cell>
                <van-cell>
                    <van-row @click="goToWhere(1)">
                            <van-col class="serve-icon">
                                <img src="../assets/car.png" class="serve-tab-img">
                            </van-col>
                            <van-col class="serviceItemDesc">
                                <div class="service-tab">我的出行</div>
                                <div class="more-detail">快乐出行，轻松无忧</div>
                            </van-col>
                    </van-row>
                </van-cell>
                <van-cell>
                    <van-row>
                        <router-link to="/epidemic">
                            <van-col class="serve-icon">
                                <img src="../assets/virus-icon.png" class="serve-tab-img">
                            </van-col>
                            <van-col class="serviceItemDesc">
                                <div class="service-tab">实时疫情</div>
                                <div class="more-detail">掌握实时疫情，安全出行</div>
                            </van-col>
                        </router-link>
                    </van-row>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>


<style lang="less">
    // 使用 Less Style 的 CSS 语法，比如嵌套表述
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .serve-list-box {
        background-color: #fff;
        .serve-icon{
            font-size: 0;line-height: 0;
            img{
                width: 48px;
            }
        }
        .van-cell{
            padding: 11px 15px 0;
        }
        .serviceItemDesc{margin-left: 10px}
    }
    .van-cell:not(:last-child)::after{border: 0}
    .van-cell__title {

    }

    .serve-list-img {
        font-size: 0;
        img {
            width: 100%;
        }
    }

    .service-list {

    }
    .serviceItemDesc {
        p {
            margin: 0;
        }

        .service-tab {
            font-size: 15px;
            color: black;
        }

        .more-detail {
            font-size: 14px;
            color: #4a4a4a;
        }
    }

</style>
<script>

    // 局部引入 axios
    //import axios from 'axios'

    export default {
        data() {
            return {
                list: [{
                    serviceName: "anti-coronavirus",
                    title: "抗疫专区",
                    description: "免费申领口罩，抗疫实时信息",
                    coverImageUrl: require("../assets/defend.png"),
                    pathName: "register"
                },
                    {
                        serviceName: "taxi",
                        title: "我的出行",
                        description: "快乐出行，轻松无忧",
                        coverImageUrl: require("../assets/car.png"),
                        pathName: "my-taxi"
                    }],
                loading: false,
                finished: false,
            };
        },
        props: ["accessToken"],
        methods: {
            // onLoad() {
            //     // 异步更新数据
            //     // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            //     this.$axios.get('/api/account/me', {
            //         headers: {
            //             'countryCode': '0'
            //         }
            //     }).then(res => {
            //         // 不使用 function (res) {} 的方式，以避免 this 指针的丢失
            //         this.loading = false;
            //         this.finished = true;
            //         console.log(res.data);
            //     }).catch(error => {
            //         // 不使用 function (error) {} 的方式，以避免 this 指针的丢失
            //         console.log("not success");
            //         console.log(error);
            //         this.$router.push("/error");
            //     });
            // }
            onLoad() {
                if(!this.$store.state.userToken){
                    this.$axios.get('/api/token/accessToken', {params: {token: this.accessToken}}).then(res => {
                        if(res.data['code']==0){
                            this.$store.commit('setUserToken', res.data['data']);
                            this.loading = false;
                            this.finished = true;
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }else{
                    this.loading = false;
                    this.finished = true;
                    console.log("token exist")
                }
            },
            goToWhere(n){
                if(this.$store.state.userToken){
                    if(n){
                        this.$router.push("/my-taxi");
                    }else {
                        this.$axios.get('/api/service/mask/info').then(res => {
                            if(res.data.data.status){
                                this.$store.commit('setUserMask', res.data.data);
                                this.$store.commit('setMaskIsApply', 1);
                                this.$router.push("/mask-info");
                            }else {
                                this.$router.push("/register");
                            }
                        }).catch(error => {
                            console.log(error);
                            // this.$router.push("/error")
                        });
                    }
                }
            }
        },
        mounted() {

        }
    }
</script>
